// extracted by mini-css-extract-plugin
export default {"root":"ImageWithDescription_root__A5q+i","gif":"ImageWithDescription_gif__abrRe","description":"ImageWithDescription_description__f95-k"};